import React, { useState, useEffect, useMemo } from "react";
import CategorySidebar from "./CategorySidebar";
import ServiceFormsTable from "./ServiceFormsTable";
import PreviewPane from "./PreviewPane";

const ServiceFormsSection = ({ categories = [], forms = [] }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [filteredForms, setFilteredForms] = useState(forms);
    const [selectedForm, setSelectedForm] = useState(null);

    // When the selected category changes, filter the forms
    useEffect(() => {
        if (!selectedCategory) {
            setFilteredForms(forms);
        } else {
            setFilteredForms(forms.filter(f => f.categoryID === selectedCategory));
        }
    }, [selectedCategory, forms]);

    const columns = useMemo(() => [
        { label: "Form Name", accessor: "displayName" },
    ], []);

    return (
        <div className="service-forms-container">
            {/* Left Sidebar */}
            <div className="service-forms-sidebar" >
                <CategorySidebar
                    categories={categories}
                    selectedCategory={selectedCategory}
                    onSelectCategory={setSelectedCategory}
                />
            </div>

            {/* Middle Table */}
            <div className="service-forms-table">
                <ServiceFormsTable
                    forms={filteredForms}
                    onSelectForm={setSelectedForm}
                />
            </div>

            {/* Right Preview */}
            {selectedForm && (
                <div className="service-forms-preview">
                    <PreviewPane form={selectedForm} />
                </div>
            )}
        </div>
    );
};

export default ServiceFormsSection;
